import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=1d7a4a93&"
import script from "./Pos.vue?vue&type=script&lang=js&"
export * from "./Pos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7a4a93')) {
      api.createRecord('1d7a4a93', component.options)
    } else {
      api.reload('1d7a4a93', component.options)
    }
    module.hot.accept("./Pos.vue?vue&type=template&id=1d7a4a93&", function () {
      api.rerender('1d7a4a93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Pos.vue"
export default component.exports